import * as fromDatatype from '../datatype-library/index';

export interface bl_dgmkt_campaign_processing_queue_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  insert_time: fromDatatype.TimestampTzDatatypeInterface;
  start_time: fromDatatype.TimestampTzDatatypeInterface;
  expire_time: fromDatatype.TimestampTzDatatypeInterface;
  event_code: fromDatatype.VarcharDatatypeInterface;
  event_properties: fromDatatype.JsonDatatypeInterface;
  priority: fromDatatype.IntegerDatatypeInterface;
  number_of_retry: fromDatatype.IntegerDatatypeInterface;
  max_retry: fromDatatype.IntegerDatatypeInterface;
}

export class bl_dgmkt_campaign_processing_queue_RowClass
  implements bl_dgmkt_campaign_processing_queue_RowInterface
{
  guid: fromDatatype.GuidDataFieldInterface;
  insert_time: fromDatatype.TimestampTzDatatypeInterface;
  start_time: fromDatatype.TimestampTzDatatypeInterface;
  expire_time: fromDatatype.TimestampTzDatatypeInterface;
  event_code: fromDatatype.VarcharDatatypeInterface;
  event_properties: fromDatatype.JsonDatatypeInterface;
  priority: fromDatatype.IntegerDatatypeInterface;
  number_of_retry: fromDatatype.IntegerDatatypeInterface;
  max_retry: fromDatatype.IntegerDatatypeInterface;
}
